<template>
    <div :class="change_color?'leftbar':'leftbar'">
        <ul>

	<!-- <li class="left_bar_block" v-for="v in goods_class" :key="v.id">{{v.name}}</li> -->


            <li class="left_bar_block" v-for="v in goods_class.slice(0, 11)" :key="v.id">
                <div class="class_1"><router-link :to="'/goods/params/?productCategoryId=' + v.id + '&productCategoryName=' + v.name" target="_blank">{{v.name}}</router-link></div>
                <!-- <div class="class_2">
                    <ul>
                        <li v-for="(vo,key) in v.children" :key="key" v-show="key<3"><router-link :to="'/goods/params/categoryId='+vo.id" target="_blank">{{vo.name}}</router-link></li>
                    </ul>
                </div> -->
                <div class="subbar">
                    <!-- <div class="subbar_top">
                        <ul>
                            <li v-for="(tag_item,tag_key) in v.tags.split(',')" :key="tag_key"><router-link :to="'/goods/params/class_id.'+v.id">{{tag_item}}</router-link></li>
                        </ul>
                    </div> -->
                    <!-- <div class="subbar_right">
                        <ul>
                            <li v-for="(goods_brand_item,goods_brand_key) in goods_brand" :key="goods_brand_key"><img width="100px" height="50px" :src="goods_brand_item.thumb" alt=""></li>
                        </ul>
                        <div class="subbar_right_adv">
                            <router-link :to="goods_brand_adv['adv'][0]['adv_link']"><img width="203px" height="96" :src="goods_brand_adv['adv'][0]['adv_image']" :alt="goods_brand_adv['adv'][0]['adv_title']"></router-link>
                        </div>
                    </div> -->
                    <div class="subbar_subnav">
                        <div class="class2_title"  v-for="(vo,key) in v.children" :key="key">
                            <h4><router-link :to="'/goods/params/?productCategoryId=' + vo.id + '&productCategoryName=' + v.name +',' +vo.name " target="_blank">{{vo.name}}</router-link></h4>
                            <ul>
                    <li v-for="(item,index) in vo.children" :key="index"><router-link :to="'/goods/params/?productCategoryId='+ item.id + '&productCategoryName='  + v.name +',' + vo.name + ',' + item.name" target="_blank">{{item.name}}</router-link></li>
                            </ul>
                        </div>
                    </div>
                    
                </div>
            </li>
        </ul>
        
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        change_color:{
            type:Boolean,
            default:false,
        }
    },
    data() {
      return {
          goods_class:[],
          goods_brand:[],
        //   goods_brand_adv:{},
      };
    },
    watch: {},
    computed: {},
    methods: {
        // 获取首页左侧导航信息
        get_subnav_info:function(){
            this.$get(this.$api.goodsCategory,{platId:this.$platId}).then(res=>{
                this.goods_class = res.data;
                //console.log(this.goods_class);
                // this.goods_brand = res.data.goods_brand;
                // this.goods_brand_adv = res.data.goods_brand_adv;
            });
        }
    },
    created() {
        this.get_subnav_info();
    },
    mounted() {}
};
</script>
<style lang="scss" scoped>
.leftbar{
    width: 240px;
    position: absolute;
    left: 0px;
    height: 480px;
    display: block;
    z-index: 998;
    color:#333;
    margin-top: 1px;
    // background: rgba(255,255,255,.7);
    background:#fff;
    text-align: left;
    // overflow: hidden;
    // padding:0 15px;
    .class_1{
        padding: 4px 15px 4px 50px;
        height: 50px;
        line-height: 50px;
        a{
            font-weight: bold;
            font-size: 15px;
        }
    }
    
    .class_2{
        padding: 0 0 6px 15px;
        font-size: 12px;
        overflow: hidden;
        box-sizing: border-box;
        width: 240px;
        height: 24px;
        ul:after{
            display: block;
            clear: both;
            content:'';
        }
        ul li{
            line-height: 18px;
            float: left;
            a{
                color:#999;
                margin-right: 15px;
            }
        }
    }
    .class_2:after{
        display: block;
        clear: both;
        content:'';
    }
    
    .left_bar_block:hover{
        background: #f5f5f5;
        .subbar{
            display: block;
        }
    }
    .subbar{
        background: #fff;
        width: 960px;
        min-height: 480px;
        height: 480px;
        position: absolute;
        top:0;
        left: 240px;
        z-index: 999;
        display: none;
        border: #409eff 1px solid;
        border-top: none;
        overflow-y:auto;
        // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .subbar_top{
            padding: 20px 0 0 20px;
            width: 680px;
            float: left;
            ul li{
                float: left;
                line-height: 25px;
                padding: 0 8px;
                background: #5f4f4f;
                margin-right: 20px;
                a{
                    color:#fff;
                    font-size: 12px;
                }
            }
            :after{
                display: block;
                content: "";
                clear: both;
            }
        }
        // .subbar_right{
        //     float: right;
        //     width: 220px;
        //     height: 450px;
        //     ul{
        //         margin-top:20px;
        //     }
        //     ul li{
        //         float: left;
        //         height: 50px;
        //         border:1px solid #eee;
        //         border-bottom: none;
        //     }
        //     ul li:nth-child(2n){
        //         border-left: none;
        //     }
        // }
    }
    .subbar_subnav{
        margin-left: 20px;
        // margin-top: 15px;
        width: 920px;
        display: block;
        float: left;
        .class2_title{
            h4{
                width: 90px;
                text-align: right;
                float: left;
                margin-right: 20px;
                font-size: 14px;
                line-height: 40px;
                height: 40px;
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            ul{
                float: left;
                width: 810px;
                li{
                    float: left;
                    padding-left: 10px;
                    padding-right: 10px;
                    margin-top: 10px;
                    margin-bottom: 0px;
                    border-left: 1px solid #ddd;
                    line-height: 20px;
                    font-size: 14px;
                    font-weight: normal;
                    a{
                        font-size: 12px;
                        color:#999;
                        
                    }
                    a:hover{
                        color:#409EFF;
                    }
                    
                }
                li:last-child{
                    margin-bottom: 14px;
                }
                border-bottom: 1px dashed #ccc;
            }
            
        }
        .class2_title:after{
            display: block;
            clear: both;
            content:'';
        }
    }
    
}
.leftbar2{
    width: 240px;
    position: absolute;
    left: 0px;
    height: 450px;
    display: block;
    z-index: 998;
    color:#fff;
    background: rgba(0,0,0,.6);
    margin-top: 1px;
    text-align: left;
    // overflow: hidden;
    // padding:0 15px;
    .class_1{
        padding: 4px 15px 4px 50px;
        a{
            // font-weight: bold;
            color:#fff;
        }
    }
    
    .class_2{
        padding: 0 0 6px 15px;
        font-size: 12px;
        overflow: hidden;
        box-sizing: border-box;
        width: 240px;
        height: 24px;
        ul:after{
            display: block;
            clear: both;
            content:'';
        }
        ul li{
            line-height: 18px;
            float: left;
            a{
                color:#bfbfbf;
                margin-right: 15px;
            }
        }
    }
    .class_2:after{
        display: block;
        clear: both;
        content:'';
    }
    
    .left_bar_block:hover{
        background: #000;
        .subbar{
            display: block;
        }
    }
    .subbar{
        background: #fff;
        width: 960px;
        height: 450px;
        position: absolute;
        top:0;
        left: 240px;
        z-index: 999;
        display: none;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .subbar_top{
            padding: 20px 0 0 20px;
            width: 680px;
            float: left;
            ul li{
                float: left;
                line-height: 25px;
                padding: 0 8px;
                background: #5f4f4f;
                margin-right: 20px;
                a{
                    color:#fff;
                    font-size: 12px;
                }
            }
            :after{
                display: block;
                content: "";
                clear: both;
            }
        }
        .subbar_right{
            float: right;
            width: 220px;
            height: 450px;
            ul{
                margin-top:20px;
            }
            ul li{
                float: left;
                height: 50px;
                border:1px solid #eee;
                border-bottom: none;
            }
            ul li:nth-child(2n){
                border-left: none;
            }
        }
    }
    .subbar_subnav{
        margin-left: 20px;
        margin-top: 15px;
        width: 680px;
        display: block;
        float: left;
        .class2_title{
            h4{
                width: 60px;
                text-align: right;
                float: left;
                margin-right: 20px;
                color:#333;
            }
            ul{
                float: left;
                width: 600px;
                li{
                    float: left;
                    padding-left: 20px;
                    padding-right: 20px;
                    border-left: 1px solid #ddd;
                    margin: 2px 0;
                    line-height: 16px;
                    a{
                        font-size: 12px;
                        color:#999;
                        
                    }
                    a:hover{
                        color:#409EFF;
                    }
                    
                }
                li:last-child{
                    margin-bottom: 14px;
                }
                border-bottom: 1px dashed #ccc;
            }
            
        }
        .class2_title:after{
            display: block;
            clear: both;
            content:'';
        }
    }
    
}
.class_1 .el-image{
    width: 22px;
    height: 22px;
}
</style>

<style scoped>
.subbar::-webkit-scrollbar {
	/*滚动条整体样式*/
	width : 8px;  /*高宽分别对应横竖滚动条的尺寸*/
	height: 8px;
	}
.subbar::-webkit-scrollbar-thumb {
	border-radius: 10px;
	box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
	background   : #409EFF;
    background-image: -webkit-linear-gradient(45deg,hsla(0,0%,100%,.2) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.2) 0,hsla(0,0%,100%,.2) 75%,transparent 0,transparent);
	}

.subbar::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
	border-radius: 10px;
	background   : #ededed;
	}

</style>